import React from 'react';

import { IconSpinner } from 'components/Icon';

const ButtonLoader = () => (
    <IconSpinner height={15} width={15} />
);

export default ButtonLoader;
